import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "store/hooks";

export function QueryParamsManager() {
    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeFilter } = useAppSelector(state => state.customersAdminPage);


    const [queryParams, setQueryParams] = useSearchParams();

    const isFirstRender = useRef(true);

    useEffect(() => {
        setQueryParams((params) => {
            if (activeSearchIdParameter) {
                params.set("searchId", String(activeSearchIdParameter))
            } else {
                params.delete("searchId")
            }

            if (activePaginationLimit) {
                params.set("limit", String(activePaginationLimit))
            } else {
                params.delete("limit")
            }

            if (activePaginationPage) {
                params.set("page", String(activePaginationPage))
            } else {
                params.delete("page")
            }

            if (activeFilter) {
                params.set("filter", activeFilter)
            } else {
                params.delete("filter")
            }

            return params
        }, {
            replace: isFirstRender.current
        })

        isFirstRender.current = false;
    }, [activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeFilter]);

    return <></>
}